/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { App } from "../../../api/apiCalls";
import AppCard from "../../Common/AppCard";

interface AppGutterHomePageProps {
  mainHeading?: string;
  subHeading?: string;
  note?: string;
  keyword?: string;
  data: App[] | undefined;
}

function AppGutterHomePage({
  mainHeading,
  subHeading,
  note,
  keyword,
  data,
}: AppGutterHomePageProps) {
  return (
    <div className="row mt-5">
      {data?.length !== 0 && (
        <div className="col-lg-2 pr-0">
          <h4 className="font-weight-bold m-0">
            {mainHeading ||
              (keyword && 'Showing results for "' + keyword + '"')}
          </h4>
          <h4 className="font-weight-bold text-secondary">{subHeading}</h4>
          <p className="sub-text">{note}</p>
        </div>
      )}
      <div className="col-lg-10">
        <div className="row no-gutters apps-row">
          {data?.map((app) => {
            return <AppCard key={app.appId} app={app} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default AppGutterHomePage;
